//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addMonths } from 'date-fns'
import { outputPdf } from '@/plugins/utils'
import { formatDate } from '@/plugins/filters'

export default {
  name: 'DownloadMenuPage',

  layout: 'page',

  data() {
    return {
      pageLoading: false,
      formLoading: false,
      submitLoading: false,
      floor: null,
      floors: null,
      plan: null,
      plans: [],
      plansMap: {},
      startMonth: addMonths(new Date(), -1),
      pickerOptions: {},
      pdfLoading: false,
      fetchLoading: false,
      downloadParams: [],
      courseId: null,
      showModal: false,
      yasaiType: null,
      yasaiTypes: [
        {
          name: '掲示向けダウンロード',
          id: 'post',
        },
        {
          name: 'リクエスト集計向けダウンロード',
          id: 'summary',
        },
      ],
      yasaiOptionsSet: {
        post: {
          title: '掲示向けダウンロード',
          intro: '掲示向けメニューをダウンロードします',
          imgUrl: '',
          version: 2,
          downloadOptions: [
            {
              id: 'dmFlg',
              label: '全商品表示',
            },
          ],
          defaultChecks: [],
        },
        summary: {
          title: 'リクエスト集計向けダウンロード（全商品表示）',
          intro: 'リクエスト集計向けメニュー（全商品表示）をダウンロードします',
          imgUrl: '',
          version: 1,
          downloadOptions: [
            {
              id: 'cpFlg',
              label: '企業価格表示',
            },
            {
              id: 'epFlg',
              label: '従業員価格表示',
            },
            {
              id: 'dmFlg',
              label: '全商品表示',
            },
          ],
          defaultChecks: ['epFlg', 'dmFlg'],
        },
      },
      yasaiList: [],
      yasaiOptions: {},
      showFloorsSet: null,
      tableGroupSizes: [],
      gohanOptionsSet: {
        post: {
          title: '掲示向けダウンロード',
          intro: '掲示向けメニューをダウンロードします',
          imgUrl: '',
          viewType: 2,
        },
        summary: {
          title: 'リクエスト集計向けダウンロード',
          intro: 'リクエスト集計向けメニューをダウンロードします',
          imgUrl: '',
          viewType: 1,
          downloadOptions: [
            {
              id: 'cpFlg',
              label: '企業価格表示',
            },
            {
              id: 'epFlg',
              label: '従業員価格表示',
            },
          ],
          defaultChecks: ['epFlg'],
        },
      },
      gohanType: null,
      gohanDownloadParams: null,
      gohanDownloadOptions: [
        {
          id: 'cpFlg',
          name: '企業価格表示',
        },
        {
          id: 'epFlg',
          name: '従業員価格表示',
        },
      ],
      gohanDownloadFilter: ['epFlg'],
      gohanListMenu: {},
    }
  },

  computed: {
    month() {
      return formatDate(this.startMonth, 'yyyy-MM')
    },
    planItem() {
      return this.plans.find((item) => item.id === this.plan)
    },
    groupId() {
      return this.planItem?.group_id
    },
    formDisabled() {
      return this.formLoading || this.submitLoading || this.pdfLoading
    },
    showFloors() {
      return this.showFloorsSet ?? this.floors?.length > 1
    },
    floorName() {
      return this.floors.find((item) => item.id === this.floor)?.name
    },
    courseList() {
      const gohanItem = this.plansMap[this.floor]?.find(
        (item) => item.group_id === 'gohan'
      )

      return gohanItem?.courseList || []
    },
    courseItem() {
      return this.courseList.find((item) => item.id === this.courseId)
    },
    // TODO: get viewTypeList.id for production api
    gohanTypes() {
      const monthItem = this.courseItem?.monthList.find(
        (item) => item.month === this.month
      )

      return monthItem?.viewTypeList || []
    },
    contentList() {
      return this.gohanTypes.find((item) => item.id === this.gohanType)
        ?.contentList
    },
    gohanDisplayType() {
      return this.contentList?.find(
        (item) => item.id === this.gohanDownloadParams
      )?.displayType
    },
    monthList() {
      switch (this.groupId) {
        case 'yasai':
          return this.planItem.monthList
        case 'gohan':
          return this.courseItem?.monthList?.map((item) => item.month)
        default:
          return []
      }
    },
    menuTitle() {
      return this.yasaiType === 'post'
        ? `オフィスでやさいメニュー表(${formatDate(
            this.startMonth,
            'M'
          )}月お届け商品)`
        : `オフィスでやさいメニュー表(${formatDate(
            this.startMonth,
            'M'
          )}月リクエスト集計向け)`
    },
    yasaiListGroup() {
      const groups = []

      if (this.yasaiType === 'summary') {
        if (this.tableGroupSizes.length < 1) {
          return [this.yasaiList]
        }

        for (let i = 0, j = 0; i < this.tableGroupSizes.length; i++) {
          const curSize = this.tableGroupSizes[i]
          groups.push(this.yasaiList.slice(j, j + curSize))
          j += curSize
        }

        return groups
      }

      const groupCount = 30

      for (let i = 0; i < this.yasaiList.length; i += groupCount) {
        groups.push(this.yasaiList.slice(i, i + groupCount))
      }

      return groups
    },
    gohanListGroup() {
      const groups = []

      if (this.gohanType === 2 && this.gohanListMenu?.list) {
        if (this.tableGroupSizes.length < 1) {
          return [this.gohanListMenu.list]
        }

        for (let i = 0, j = 0; i < this.tableGroupSizes.length; i++) {
          const curSize = this.tableGroupSizes[i]
          groups.push(this.gohanListMenu.list.slice(j, j + curSize))
          j += curSize
        }

        return groups
      }

      const countMap = {
        1: 30,
        2: 24,
        3: 6,
      }
      const groupCount = countMap[this.gohanDisplayType]

      for (let i = 0; i < this.gohanListMenu?.list?.length; i += groupCount) {
        groups.push(this.gohanListMenu.list.slice(i, i + groupCount))
      }

      return groups
    },
  },

  watch: {
    floor(newValue) {
      if (!newValue) {
        return
      }

      this.plans = this.plansMap[newValue]
      this.plan = this.plans.find((item) => item.id === this.plan)
        ? this.plan
        : this.plans[0]?.id

      this.updateDatePicker()

      if (this.groupId === 'gohan') {
        this.courseId = this.courseList.find(
          (item) => item.id === this.courseId
        )
          ? this.courseId
          : this.courseList[0]?.id
      }
    },
    plan(newValue) {
      if (!newValue) {
        return
      }

      if (this.groupId === 'gohan') {
        this.courseId = this.courseList[0]?.id
      }

      this.updateDatePicker()
    },
    courseId(newValue) {
      if (!newValue) {
        return
      }

      this.updateDatePicker()
    },
    gohanTypes(newValue) {
      this.gohanType = newValue.find((item) => item.id === this.gohanType)
        ? this.gohanType
        : newValue[0]?.id
    },
  },

  mounted() {
    this.fetchOptions(false)
  },

  methods: {
    async fetchOptions() {
      this.formLoading = true

      const res = await this.$axios.$get('/download/menu/options')

      this.formLoading = false

      const { floors, show_floor_name: showFloorName, images } = res.data

      this.floors = floors.map((item) => ({
        id: item.id,
        name: item.name,
      }))
      this.floor = this.floors[0]?.id
      this.showFloorsSet = showFloorName

      this.yasaiOptionsSet.post.imgUrl = images.url_posting_yasai
      this.yasaiOptionsSet.summary.imgUrl = images.url_posting_yasai

      this.gohanOptionsSet.post.imgUrl = images.url_posting_gohan
      this.gohanOptionsSet.summary.imgUrl = images.url_totaling_gohan

      const plans = {}

      floors.map((item) => {
        plans[item.id] = item.plans

        return item
      })

      this.plansMap = plans
      this.plans = this.plansMap[this.floor]
      this.plan = this.plans[0].id

      const firstCourse = this.plans.find((item) => item.group_id === 'gohan')
        ?.courseList[0]

      this.courseId = firstCourse?.id

      const firstItem = this.plansMap[this.floor][0]
      const firstMonth =
        firstItem.group_id === 'yasai'
          ? firstItem.monthList[0]
          : firstItem.courseList[0]?.monthList[0]?.month

      this.startMonth = new Date(firstMonth)
    },
    doFormChange() {
      this.$nextTick(() => {
        switch (this.groupId) {
          case 'yasai':
            this.fetchYasaiPreview()
            break
          case 'gohan':
            this.fetchGohanPreview()
            break

          default:
            break
        }
      })
    },
    async fetchYasaiList() {
      this.fetchLoading = true

      const params = {
        id: this.floor,
        month: this.month,
        plan: this.plan,
      }

      this.downloadParams.forEach((item) => {
        params[item] = 1
      })

      const res = await this.$axios.$get('/download/menu/products/yasai', {
        params,
      })

      this.fetchLoading = false

      const { list } = res.data

      this.yasaiList = this.downloadParams.includes('dmFlg')
        ? list
        : list.filter((item) => item.requested)

      if (this.yasaiType === 'summary') {
        this.tableGroupSizes = []

        this.$nextTick(() => {
          this.rejustTableGroupSize()
        })
      }
    },
    async fetchGohanList() {
      this.fetchLoading = true

      const res = await this.$axios.$get('/download/menu/products/gohan', {
        params: {
          floor: this.floor,
          month: this.month,
          viewTypeListId: this.gohanType,
          contentId:
            this.gohanType === 1
              ? this.gohanDownloadParams
              : this.contentList[0].id,
          plan: this.plan,
        },
      })

      this.fetchLoading = false
      this.gohanListMenu = res.data

      if (this.gohanType === 2) {
        this.tableGroupSizes = []

        this.$nextTick(() => {
          this.rejustTableGroupSize()
        })
      }
    },
    doYasaiTypeChange() {
      this.yasaiOptions = this.yasaiOptionsSet[this.yasaiType]
      this.downloadParams = this.yasaiOptions.defaultChecks

      this.fetchYasaiPreview()
    },
    fetchYasaiPreview(value) {
      if (this.groupId !== 'yasai' || !this.yasaiType) {
        return
      }

      this.$nextTick(() => {
        this.fetchYasaiList()
      })
    },
    fetchGohanPreview() {
      if (this.groupId !== 'gohan' || this.gohanType === null) {
        return
      }

      if (!this.gohanDownloadParams) {
        this.gohanDownloadParams = this.contentList?.[0].id
      }

      this.$nextTick(() => {
        this.fetchGohanList()
      })
    },
    updateDatePicker() {
      if (this.monthList?.length) {
        this.$set(this.pickerOptions, 'disabledDate', (time) => {
          return !this.monthList.includes(formatDate(time, 'yyyy-MM'))
        })

        this.startMonth = new Date(this.monthList[0])
      } else {
        this.$set(this.pickerOptions, 'disabledDate', {})
      }
    },
    rejustTableGroupSize() {
      const trs = document.querySelectorAll(
        '.list-product-table > .el-table__body-wrapper tr'
      )
      const marginTop = 111
      const marginBottom = 48
      const perPageHeight = 1633 - marginTop - marginBottom
      const pageSizes = []

      let pageHeight = 0
      let curPageSize = 0

      for (let i = 0; i < trs.length; i++) {
        const tr = trs[i]

        pageHeight += tr.offsetHeight
        curPageSize += 1

        if (i === trs.length - 1) {
          pageSizes.push(curPageSize)

          break
        }

        const trNext = trs[i + 1]

        if (trNext && pageHeight + trNext.offsetHeight > perPageHeight) {
          pageSizes.push(curPageSize)

          pageHeight = 0
          curPageSize = 0
        }
      }
      this.tableGroupSizes = pageSizes
    },
    async yasaiDownload() {
      const $dom = document.getElementById('menu-list')
      const dom = $dom.cloneNode(true)
      const $pdfWrap = document.getElementById('menu-list-pdf-wrap')

      dom.id = 'menu-list-pdf'

      $pdfWrap.append(dom)

      const pdfOpts = {}

      if (this.yasaiType === 'post') {
        pdfOpts.a4Width = 595
        // pdfOpts.mode = 'preview'
      }

      this.pdfLoading = true

      await outputPdf($pdfWrap, `${this.menuTitle}.pdf`, pdfOpts)

      this.pdfLoading = false

      $pdfWrap?.replaceChildren?.()
    },
    async gohanDownload() {
      const $dom = document.getElementById('menu-list')
      const dom = $dom.cloneNode(true)
      const $pdfWrap = document.getElementById('menu-list-pdf-wrap')

      dom.id = 'menu-list-pdf'

      $pdfWrap.append(dom)

      const pdfOpts = {}

      pdfOpts.a4Width = 595

      if (this.gohanType === 2) {
        pdfOpts.marginBottom = 88
      }

      // pdfOpts.mode = 'preview'

      this.pdfLoading = true

      await outputPdf($pdfWrap, `${this.gohanListMenu?.title}.pdf`, pdfOpts)

      this.pdfLoading = false

      $pdfWrap?.replaceChildren?.()
    },
  },
}
